import { Component, OnInit, Input, OnChanges, SimpleChange, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ProductTypePipe } from "../product-type.pipe";

import { Domain as WebsideDomain } from "../../../../lib/Domain/Webside";
import { Domain as ProductDomain } from "../../../../lib/Domain/Product";
import { Domain } from '../../../../lib/Domain';
@Component({
  selector: 'app-product-edit',
  templateUrl: './product-edit.component.html',
  styleUrls: ['./product-edit.component.css']
})
export class ProductEditComponent implements OnInit {
  @Output() Save = new EventEmitter();
  @Output() Close = new EventEmitter();
  @Input() Item: WebsideDomain.IProduct = undefined;
  public modalTitle = "建立新產品";
  public productTypelists: any[] = ProductTypePipe.getType();
  public errMsg = "";
  private isCreated = true;
  private serialModelHeader: string;
  constructor() { }


  OnSubmit() {
    if (this.isCreated) {

    }
    if (this.Save) {
      this.Save.emit({
        Item: this.Item, isCreated: this.isCreated, callback: (erro: Error) => {
          if (erro) {
            this.errMsg = erro.message;
          } else {
            this.OnClose();
          }

        }
      });

    }
  }
  OnClose() {
    if (this.Close) {
      this.Close.emit();
    }
  }
  OnFindModel(str: string) {
    if (str.length >= 3) {
      this.serialModelHeader = str.substring(0, 3).toUpperCase();
      if (this.Item) {
        this.Item.type = ProductTypePipe.deviceNO2Type(this.serialModelHeader);
      }
    } else {
      if (this.Item) {
        this.Item.type = undefined;
      }
    }
  }

  ngOnInit() {

  }

  ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
    if (changes['Item'] && this.Item) {
      this.isCreated = false;
      this.modalTitle = `編輯產品`;
      this.Item = {
        uuid: this.Item.uuid,
        type: this.Item.type,
        serialno: this.Item.serialno,
        name: this.Item.name,
        lastuploaddate: this.Item.lastuploaddate,
        hash: this.Item.hash,
        enablecontrol: this.Item.enablecontrol,
        enable: this.Item.enable,
        deviceserialno: this.Item.deviceserialno,
        description: this.Item.description,
        createdate: this.Item.createdate,
        createby: 0x120
      };

    } else if (changes['Item'].currentValue === undefined) {
      this.isCreated = true;
      this.modalTitle = "建立產品";
      this.Item = {
        uuid: "",
        type: undefined,
        serialno: "",
        name: "",
        hash: "",
        enablecontrol: false,
        enable: true,
        deviceserialno: "",
        description: "",
        createdate: new Date(),
        createby: 0x120
      };
    }
  }
}



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/product-edit/product-edit.component.ts